var map = {
	"./pair-dice.svg": "10eb",
	"./pair-figma.svg": "1200",
	"./pair-sketch.svg": "1fbc",
	"./pair-vscode.svg": "27a1",
	"./pair-xd.svg": "82bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d56d";